import React from "react";
import { useRecoilValue } from "recoil";
import { Box } from "@mui/material";
import { studyHistoryLoadingState, studyHistoryState } from "features/optimization/state/studyAtoms";
import { useOptimizationSelection } from "features/optimization/hooks/useOptimizationSelection";
import { OptimizationHistoryAutocomplete } from "./OptimizationHistoryAutocomplete";

export const OptimizationSelector: React.FC = () => {
  const studyHistory = useRecoilValue(studyHistoryState);
  const studyHistoryLoading = useRecoilValue(studyHistoryLoadingState);
  const { selectedStudyName, handleSelectedStudyChange } = useOptimizationSelection();

  return (
    <Box component="div" sx={{ paddingTop: 1, paddingBottom: 1 }}>
      <OptimizationHistoryAutocomplete
        history={studyHistory}
        selectedName={selectedStudyName}
        loading={studyHistoryLoading}
        onSelectedNameChange={handleSelectedStudyChange}
      />
    </Box>
  );
};
